module.exports = __webpack_public_path__ + "static/rate-comparison-0887bd69fa555c5288033340f811dd15.png";